export default {
  ADMIN: 1,
  CLIENT: 2,
  SYSTEM_ADMIN: 3
}